import Login from "../../components/Forms/LoginForm/LoginForm";

const LoginPage = () => {
    return <Login />;
};

export default LoginPage;
